// extracted by mini-css-extract-plugin
var _1 = "EmailCreationFormInlineContent-moduleEmailCreationFormInlineContent__TLKFN";
export { _1 as "EmailCreationFormInlineContent" }
